import axios from 'axios';
import { YmmParams } from './types';

/**
 * Fetch YMM data using the Next.js API proxy route to avoid CORS issues
 */
export const fetchYmmData = async (params: YmmParams) => {
  try {
    // Use relative URL - axios will automatically use current origin
    const response = await axios.get('/api/ymm', {
      params,
      headers: {
        'Accept': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('YMM API Error:', error);

    // Handle axios errors
    if (axios.isAxiosError(error)) {
      const message = error.response?.data?.error || error.response?.statusText || error.message;
      throw new Error(`Failed to fetch data: ${message}`);
    }

    throw new Error(`Failed to fetch data: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}